import React from 'react';
import Paragraph from '../typography/paragraph';
import RatingStars from './rating.stars';
import { RatingContainer } from './rating.styles';

const Ratings = (): JSX.Element => {
  return (
    <RatingContainer to={`/member-reviews`} id="_ratings">
      <RatingStars />
      <Paragraph
        text="4.8 out of 5"
        size=".85em"
        weight="normal"
      />
      <Paragraph
        text="19k ratings"
        size=".85em"
        weight="light"
      />
    </RatingContainer>
  )
}

export default Ratings;
